/* The zoho-form script. Built by tools/build-assets.mjs from the review set; edit the review set, not this file. */
/* XGO web: the live packages page script, 2026-09-17 capture. Two edits only: short ids, and figures of 1,000 and over carry a separator. */

(function () {
  var root = document.documentElement;
  if (!root || root.dataset.xgoZohoForm) return;
  root.dataset.xgoZohoForm = '1';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO  = 'IntersectionObserver' in window;
  var SENS   = { yes: 'Yes', opt: 'Optional', na: 'Not fitted' };
  /* ---------- the enquiry form sizes itself ----------
     A cross-origin iframe cannot measure its own content from out
     here, so a fixed height gives you one of two bad outcomes: dead
     space under a short form, or - on a phone - a second scrollbar
     INSIDE the page, which is the same trap the reviews rail had.
     Zoho posts "formperma|height" to the parent as its form grows,
     so listen for that and set the height. The page then scrolls and
     the form never scrolls inside itself, at whatever length it ends
     up, including when conditional fields or validation errors make
     it taller mid-session.
     Nothing is trusted before it is checked: the message has to come
     from the iframe's own origin, name that iframe's own form and
     carry a plausible number. If it never arrives - script blocked,
     Zoho changes the contract - the min-height from the settings
     still applies and the form still works with its own scrollbar. */
  var embed = root.querySelector('.ti-enq__embed');
  if (embed) {
    var frames = [].slice.call(embed.querySelectorAll('iframe'));
    /* The UTM pass the live fleet page makes (PORT-NOTES 6): where Zoho's own tracking script has defined ZFAdvLead or ZFLead,
       the campaign values it holds are added to the form's address before it loads, so a lead carries where it came from.
       Without that script nothing changes. */
    frames.forEach(function (f) {
      var src = f.getAttribute('src') || '';
      if (src.indexOf('formperma') < 0) return;
      try {
        if (typeof ZFAdvLead !== 'undefined' && typeof zfutm_zfAdvLead !== 'undefined') {
          for (var a = 0; a < ZFAdvLead.utmPNameArr.length; a++) {
            var ap = ZFAdvLead.utmPNameArr[a];
            ap = (ZFAdvLead.isSameDomian && ZFAdvLead.utmcustPNameArr.indexOf(ap) === -1) ? 'zf_' + ap : ap;
            var av = zfutm_zfAdvLead.zfautm_gC_enc(ZFAdvLead.utmPNameArr[a]);
            if (typeof av !== 'undefined' && av !== '') src += (src.indexOf('?') > 0 ? '&' : '?') + ap + '=' + av;
          }
        }
        if (typeof ZFLead !== 'undefined' && typeof zfutm_zfLead !== 'undefined') {
          for (var l = 0; l < ZFLead.utmPNameArr.length; l++) {
            var lp = ZFLead.utmPNameArr[l];
            var lv = zfutm_zfLead.zfutm_gC_enc(ZFLead.utmPNameArr[l]);
            if (typeof lv !== 'undefined' && lv !== '') src += (src.indexOf('?') > 0 ? '&' : '?') + lp + '=' + lv;
          }
        }
      } catch (err) {}
      if (src !== f.getAttribute('src')) f.setAttribute('src', src);
    });
    if (frames.length) {
      window.addEventListener('message', function (e) {
        if (typeof e.data !== 'string' || e.data.indexOf('|') < 0) return;
        var bits = e.data.split('|');
        if (bits.length !== 2) return;
        var perma = bits[0].trim();
        var h = parseInt(bits[1], 10);
        if (!perma || isNaN(h) || h < 200 || h > 20000) return;
        frames.forEach(function (f) {
          var src = f.getAttribute('src') || '';
          if (src.indexOf('formperma') < 0 || src.indexOf(perma) < 0) return;
          var origin;
          try { origin = new URL(src, window.location.href).origin; } catch (err) { return; }
          if (e.origin !== origin) return;
          var next = (h + 15) + 'px';
          if (f.style.height === next) return;
          f.style.height = next;
          /* the floor was only there to stop a 500px stub - once the
             form has told us its real height, honour it exactly */
          f.style.minHeight = '0px';
        });
      }, false);
    }
  }

})();
